(function($){
	
	var baseClassName = "c-modalBase";
	var hasModalClassName = "has-modal";
	
	var sheetID = "modal_controller_css";
	var sheet = OH.dynamicCSS.register(sheetID, true);
	if(!!sheet){
		sheet.addRule("."+baseClassName+"{ position:fixed;top:0px;left:0px;width:100%;height:100%;white-space:nowrap;text-align:center; }");
		sheet.addRule("."+baseClassName+":before,.c-modalBase:after{ content:'';display:inline-block;width:0px;height:100%;vertical-align:middle; }");
		sheet.addRule("."+baseClassName+"__content{ display:inline-block;vertical-align:middle;white-space:normal;text-align:left; }");
	}
	
	var tasks = {
		_base : function($innerPanel){
			var $pad = $('<div>').addClass(baseClassName);
			var $contentBox = $('<div>').addClass(baseClassName + "__content");
			
			var $closer = (function(){
				var $elm = $('<div>').addClass(baseClassName + "__closer");
				// todo:jsで挿入するアイコンの指定がベタなのをどうにかする
				var $icon = $('<svg class="c-icon is-small" width="16" height="16"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#close"></use></svg>');
				$elm.append($icon).append($('<span>').text("閉じる"));
				return $elm;
			})();
			
			
			$pad.on("click", function(event){
				tasks._close();
			});
			$contentBox.on("click", function(event){
				event.stopPropagation();
			});
			$closer.on("click", function(event){
				event.stopPropagation();
				tasks._close();
			});
			
			$contentBox.on("scroll", function(event){
				$closer.css("top", $(this).scrollTop());
			});
			
			OH.abortScroll(true);
			if(!!$innerPanel){
				$(document.body).append($pad.append($contentBox.append($innerPanel).append($closer)));
			}
			else{
				$(document.body).append($pad.append($contentBox.append($closer)));
			}
			return $contentBox;
		},
		_close : function(){
			$('.' + baseClassName).each(function(){
				$(this).remove();
			});
			OH.abortScroll(false);
		},
		
		infomodal : function($parent){
			var $panel = $parent.find('.c-infoModal').eq(0);
			tasks._base($panel.clone(true).show());
		}
	};
	
	OH.modalController = {
		staticModal : function($parent){
			for(var type in tasks){
				(function(t){
					$parent.find('a[href$="#show:' + t + '"]').each(function(){
						$(this).on("click", function(event){
							event.preventDefault();
							tasks[t]($parent);
						});
					});
				})(type);
			}
		},
		maxsizeModal : function(){
			return tasks._base();
		}
	};

})(jQuery);